export default function isUsingGPC(regionSetting) {
  if ( !regionSetting.enable_do_not_sell ) {
    return false
  }

  return Boolean(regionSetting.enable_gpc && navigator.globalPrivacyControl)
}
